import {Component, ElementRef, Inject, LOCALE_ID, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProgressService} from '../../service/progress.service';
import {BaseModalComponent} from '../../common/modal/base-modal/base-modal.component';
import {Contest} from '../../model/contest/Contest';
import {CopyDataHelper} from '../../helper/copy-data.helper';
import {NotificationHandler} from '../../helper/notification.handler';
import {ContestService} from '../../service/contest.service';

export interface ContestTaskCopyDetailsData {
  competitionId: string;
  contest: Contest;
}

@Component({
  selector: 'contest-task-clone-select-modal',
  templateUrl: './contest-task-clone-select-modal.component.html',
  styleUrls: ['./contest-task-clone-select-modal.component.scss'],
})
export class ContestTaskCloneSelectModalComponent extends BaseModalComponent {

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;
  readonly contest?: Contest;
  readonly competitionId?: string;

  private selectedContest?: Contest;

  constructor(dialogRef: MatDialogRef<ContestTaskCloneSelectModalComponent>,
              progressService: ProgressService,
              private contestService: ContestService,
              @Inject(MAT_DIALOG_DATA) data: ContestTaskCopyDetailsData,
              @Inject(LOCALE_ID) private locale: string) {
    super(dialogRef, progressService);

    this.contest = data.contest;
    this.competitionId = data.competitionId;
  }

  proceed(): void {
    if (!this.contest || !this.selectedContest) return;

    this.startProgress();

    this.contestService.cloneTasks(this.contest.id, this.selectedContest.id).subscribe({
      next: () => {
        this.closeModal({
          contest: this.selectedContest
        });
        this.stopProgress();
      },
      error: error => {
        NotificationHandler.handleError($localize`:Notifications|Contest tasks copy has failed message@@notifications-contest-tasks-copy-failed-error:Contest tasks copy has failed`, error);
        this.stopProgress();
      }
    });
  }

  proceedAllowed(): boolean {
    return !!this.contest?.id && !!this.selectedContest && this.selectedContest.id != this.contest?.id;
  }

  copyMessage(val: string) {
    CopyDataHelper.copyMessage(val);
  }

  contestSelected(contest: Contest) {
    if (contest.id == this.contest?.id) {
      this.selectedContest = undefined;
      return;
    }
    this.selectedContest = contest;
  }
}
